var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeardOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-527 15295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(527 -15295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.181,203.593a.539.539,0,0,0-.756.615,3.188,3.188,0,0,1-.851,2.56c-1.442,1.083-3.47.513-4.929-1.393-1.241-1.619-2.717-2.462-4.13-2.365a3.313,3.313,0,0,0-2.288,1.178,3.314,3.314,0,0,0-2.29-1.178c-1.42-.095-2.889.746-4.13,2.365-1.458,1.9-3.485,2.477-4.929,1.393a3.184,3.184,0,0,1-.851-2.56.539.539,0,0,0-.756-.615c-.944.449-2.269,2.334-1.213,4.855a6.31,6.31,0,0,0,3.653,3.531,9.017,9.017,0,0,0,6.849-.385,10.713,10.713,0,0,0,3.665-2.672,10.715,10.715,0,0,0,3.665,2.672,8.967,8.967,0,0,0,6.849.385,6.317,6.317,0,0,0,3.653-3.531c1.056-2.521-.269-4.406-1.214-4.855Z",
    transform: "translate(416.272 -15484.502)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeardOff);
export default __webpack_public_path__ + "static/media/beardOFF.26f6a04f1e18ce712419e0b8832a414f.svg";
export { ForwardRef as ReactComponent };